import { Users, Briefcase, Clock, CheckCircle } from "lucide-react";

interface DispatchStatsProps {
  availableCrews: number;
  scheduledJobs: number;
  inProgressCount: number;
  completedToday: number;
}

export function DispatchStats({ 
  availableCrews, 
  scheduledJobs, 
  inProgressCount, 
  completedToday 
}: DispatchStatsProps) {
  const stats = [
    {
      icon: Users,
      label: "Available Crews",
      value: availableCrews,
      color: "text-primary",
      bgColor: "bg-primary/10"
    },
    {
      icon: Briefcase,
      label: "Scheduled Jobs",
      value: scheduledJobs,
      color: "text-secondary",
      bgColor: "bg-secondary/10"
    },
    {
      icon: Clock,
      label: "In Progress",
      value: inProgressCount,
      color: "text-warning",
      bgColor: "bg-warning/10"
    },
    {
      icon: CheckCircle,
      label: "Completed Today",
      value: completedToday,
      color: "text-success",
      bgColor: "bg-success/10"
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div 
            key={index}
            className="premium-card p-4 flex items-center gap-3 hover:scale-105 transition-transform"
          >
            <div className={`p-3 rounded-lg ${stat.bgColor}`}>
              <Icon className={`w-5 h-5 ${stat.color}`} />
            </div>
            <div>
              <p className="text-2xl font-bold">{stat.value}</p>
              <p className="text-xs text-muted-foreground">{stat.label}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
